'use strict';
import classNames from 'classnames';
import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import noop from 'lodash/noop';
import * as T from 'prop-types';
import React, {Component} from 'react';
import {FormField, INPUT_TYPES} from '../../../components/forms/FormField';
import {I18nComponent} from '../../../core-utilities/react-i18n/I18nComponent';


export class BaseFileRequirementFormView extends Component {
  static propTypes = {
    className: T.string,
    /** @type {String} fieldClass The class applied to each field */
    fieldClass: T.string,

    // values
    model: T.object,
    internalModel: T.object,

    canEdit: T.object,
    constraints: T.object,

    // Events
    onChange: T.object.isRequired,
    onSave: T.func.isRequired,

    // Form State
    isEditing: T.bool,
    isSaving: T.bool,

    templateWarningLabel: T.string,
    nameLabel: T.string,
    minFilesLabel: T.string,
    maxFilesLabel: T.string,
    enforcedLabel: T.string,
    yesLabel: T.string,
    noLabel: T.string,
    descriptionLabel: T.string,
  };

  constructor(props) {
    super(props);

    this.handleValidateMin = this.handleValidateMin.bind(this);
    this.handleValidateMax = this.handleValidateMax.bind(this);
  }

  render() {
    const props = this.props;
    const canEdit = props.canEdit || {};
    const constraints = props.constraints || {};
    const internalModel = props.internalModel || {};
    const onChange = props.onChange || {};

    const handleChangeName = onChange.name || noop;
    const handleChangeMinimumFileCount = onChange.minimumFileCount || noop;
    const handleChangeMaximumFileCount = onChange.maximumFileCount || noop;
    const handleChangeCountIsEnforced = onChange.countIsEnforced || noop;
    const handleChangeDescription = onChange.description || noop;

    return (
      <form
        className={classNames("FileRequirementForm", props.className)}
        onSubmit={props.onSave}
      >
        <input
          type="submit"
          hidden={true}
        />
        {props.isEditing && !canEdit.name ? (
          <div
            className="qa-warning subtle"
            title={props.templateWarningLabel}
          >
            <i className="icon ion-alert-circled" />
            <span>
              {props.templateWarningLabel}
            </span>
          </div>
        ) : null}
        <FormField
          className={classNames("FileRequirementForm__field", props.fieldClass)}
          type={INPUT_TYPES.text}
          label={props.nameLabel}
          value={internalModel.name}
          disabled={!canEdit.name}
          validateImmediately={props.validateImmediately}
          isEditing={props.isEditing}
          isSaving={props.isSaving}
          constraints={constraints.name}
          onChange={handleChangeName}
        />
        <FormField
          className={classNames("FileRequirementForm__field", props.fieldClass)}
          type={INPUT_TYPES.number}
          label={props.minFilesLabel}
          value={internalModel.minimumFileCount}
          validateImmediately={props.validateImmediately}
          isEditing={props.isEditing}
          isSaving={props.isSaving}
          constraints={constraints.minimumFileCount}
          onChange={handleChangeMinimumFileCount}
          onValidate={this.handleValidateMin}
        />
        <FormField
          className={classNames("FileRequirementForm__field", props.fieldClass)}
          type={INPUT_TYPES.number}
          label={props.maxFilesLabel}
          value={internalModel.maximumFileCount}
          validateImmediately={props.validateImmediately}
          isEditing={props.isEditing}
          isSaving={props.isSaving}
          constraints={constraints.maximumFileCount}
          onChange={handleChangeMaximumFileCount}
          onValidate={this.handleValidateMax}
        />
        <FormField
          className={classNames("FileRequirementForm__field", props.fieldClass)}
          type={INPUT_TYPES.checkbox}
          label={props.enforcedLabel}
          value={internalModel.countIsEnforced}
          trueValue={props.yesLabel}
          falseValue={props.noLabel}
          validateImmediately={props.validateImmediately}
          isEditing={props.isEditing}
          isSaving={props.isSaving}
          constraints={constraints.countIsEnforced}
          onChange={handleChangeCountIsEnforced}
        />
        <FormField
          className={classNames("FileRequirementForm__field", props.fieldClass)}
          type={INPUT_TYPES.text_long}
          label={props.descriptionLabel}
          value={internalModel.description}
          validateImmediately={props.validateImmediately}
          isEditing={props.isEditing}
          isSaving={props.isSaving}
          constraints={constraints.description}
          onChange={handleChangeDescription}
        />
      </form>
    );
  }

  /**
   * @param prev
   * @param next
   * @return {?{value: number, error: null}}
   * @private
   */
  handleValidateMin({prev, next}) {
    const max = get(this.props, 'internalModel.maximumFileCount');
    if (isNumber(max) && isNumber(next) && next > max) {
      return {
        value: max,
        error: null,
      };
    } else {
      return null;
    }
  }

  /**
   * @param prev
   * @param next
   * @return {?{value: number, error: null}}
   * @private
   */
  handleValidateMax({prev, next}) {
    const min = get(this.props, 'internalModel.minimumFileCount');
    if (isNumber(min) && isNumber(next) && next < min) {
      return {
        value: min,
        error: null,
      };
    } else {
      return null;
    }
  }
}

export const FileRequirementFormView = I18nComponent(BaseFileRequirementFormView, [
  {code: 'requirements.details.configuredbytemplate.warning.label', prop: 'templateWarningLabel'},
  {code: 'requirements.files.details.name.label', prop: 'nameLabel'},
  {code: 'requirements.files.details.min.label', prop: 'minFilesLabel'},
  {code: 'requirements.files.details.max.label', prop: 'maxFilesLabel'},
  {code: 'requirements.files.details.enforced.label', prop: 'enforcedLabel'},
  {code: 'default.yes.label', prop: 'yesLabel'},
  {code: 'default.no.label', prop: 'noLabel'},
  {code: 'requirements.files.details.description.label', prop: 'descriptionLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/requirements/components/FileRequirementForm/FileRequirementFormView.js